'use client';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const PhoneInputWrapper = styled.div`
  margin-top: ${Spacers.LG}rem;
`;

export const Container = styled.div`
  display: flex;
  gap: ${Spacers.XS}rem;
`;

export const CodeContainer = styled.div`
  display: flex;
  align-items: center;
  padding: ${Spacers.SM}rem ${Spacers.BASE}rem;
  height: 2.625rem;
  background-color: ${({ theme }) => theme.colors.backgroundAccent};
  border-radius: ${Spacers.XS}rem;
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  gap: ${Spacers.XS}rem;
  width: 7.1rem;
`;

export const CountryCodeText = styled.span`
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.lineHeight};
`;
